export default "__VITE_PUBLIC_ASSET__ddf61ce1__"